/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Backdrop from "@mui/material/Backdrop";
import Icon from "@mui/material/Icon";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React examples
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";

const initAttr = {
  id: "",
  code: "",
  customer_name: "",
  payment_type: "cash",
  date_receipt: "",
  amount: "",
  remark: "",
  user_name: "",
  image: "",
  bank_name: "",
  account_name: "",
  account_no: "",
  status: "paid",
};

function InvoiceReceiptOpen({ parent }) {
  const mod = "invoice_receipt";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const [attr, setAttr] = useState(initAttr);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const open = () => {
    setLoading(true);
    setAttr(initAttr);
    setList([]);

    FetchData("GET", `/${mod}/${parent.id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === "ok") {
        setAttr(result.data);
        setList(result.list);

        setLoading(false);
      }
    });
  };

  const paymentDisplay = (input) => {
    if (input === "cash") return "เงินสด";
    if (input === "transfer") return "โอนเงิน";
    return "";
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderCash = () => {
    return (
      <MDBox p={1}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label="วันชำระ"
              value={Func.dateDisplay(attr.date_receipt)}
              variant="standard"
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label="วิธีการชำระ"
              value={paymentDisplay(attr.payment_type)}
              variant="standard"
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label="จำนวนชำระ"
              value={attr.amount}
              variant="standard"
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label="หมายเหตุ"
              value={attr.remark}
              variant="standard"
              multiline
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderTransfer = () => {
    return (
      <Grid container mb={3} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <Paper variant="outlined" sx={{ padding: 2, marginBottom: 2 }}>
            <MDTypography variant="h5" mb={2}>
              ข้อมูลการชำระ
            </MDTypography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label="วันชำระ"
                  value={Func.dateDisplay(attr.date_receipt)}
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="วิธีการชำระ"
                  value={paymentDisplay(attr.payment_type)}
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="จำนวนชำระ"
                  value={attr.amount}
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="ธนาคารโอนเงิน"
                  value={attr.bank_name}
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="ชื่อบัญชีโอนเงิน"
                  value={attr.account_name}
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="เลขบัญชีโอนเงิน"
                  value={attr.account_no}
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="หมายเหตุ"
                  value={attr.remark}
                  variant="standard"
                  multiline
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <MDTypography variant="h5" mb={2}>
              สลิปโอนเงิน
            </MDTypography>
            <MDBox component="img" src={attr.image} alt={attr.code} width="100%" height="100%" />
          </Paper>
        </Grid>
      </Grid>
    );
  };

  const renderOpen = () => {
    return (
      <Dialog
        open={modalOpen}
        maxWidth={attr.payment_type === "transfer" ? "lg" : "xs"}
        keepMounted
        aria-describedby="dialog-add"
        fullWidth
        onClose={() => setModalOpen(false)}
      >
        <DialogTitle>
          #{attr.code}
          <IconButton
            aria-label="close"
            onClick={() => setModalOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {attr.payment_type === "transfer" ? renderTransfer() : renderCash()}
        </DialogContent>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
  }, []);

  return (
    <div>
      <MDButton
        variant="text"
        color="info"
        size="small"
        sx={{ fontSize: "1rem", whiteSpace: "nowrap" }}
        onClick={() => {
          open();
          setModalOpen(true);
        }}
      >
        {parent.code}
      </MDButton>
      {renderOpen()}
      {renderLoading()}
    </div>
  );
}

InvoiceReceiptOpen.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  }).isRequired,
};

export default InvoiceReceiptOpen;
